import { useEffect } from "react";
import { useTheme } from "./contexts/NewThemeContext";

export default function FaviconUpdater() {
  const { favicon: faviconUrl } = useTheme() || {};

  useEffect(() => {
    if (faviconUrl) {
      let faviconLink = document.querySelector("link[rel='icon']");
      if (!faviconLink) {
        faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        faviconLink.type = "image/png";
        document.head.appendChild(faviconLink);
      }
      faviconLink.href = faviconUrl;
    }
  }, [faviconUrl]);

  return null;
}
